module.exports = __webpack_public_path__ + "img/shipo-icon-notification.7f64382c.svg";